import * as d3 from 'd3';
export function createPath() {
    const projection = d3.geoAlbersUsa().scale(1280).translate([480, 300]);
    return d3.geoPath().projection(projection);
}
